export const PRODUCT_TYPES = {
  shoes: 'shoes',
  apparel: 'apparel',
  accessories: 'accessories',
  giftCards: 'gift_cards',
  magazine: 'magazine',
}

export const MEDIA_GALLERY_POSITIONS = {
  nearBottom: 'near-bottom',
  belowPurchasePod: 'below-purchase-pod',
  hidden: 'hidden',
}

export const PRODUCTS_WITH_DOWNPAYMENT = ['cloudneo', 'cyclon']
